import script from "./GenericMixin.vue?vue&type=script&lang=js"
export * from "./GenericMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__